
import React, { useEffect, useState } from 'react';

import ExternalConfiguration from '../../external-configuration';

// import './Wrapper-custom-3-s73.css';

const Constants = {
  PlayerId: 'custom-3-s73-player',
  PlayerScritpSrc: `${ExternalConfiguration.SelfHostedExternalSrcPaths.custom_3_player}/jwplayer.js`,
  S73ScriptSrc: `${ExternalConfiguration.SelfHostedExternalSrcPaths.s73}/s73-sdk-jwplayer.js`,
  S73SdkConfig: {
    apiKey: ExternalConfiguration.Credentials.S73ApiKey,
    // contentSteeringEndpoint: '<YOUR_CONTENT_STEERING_RESOURCE>', // optional
    // channelId: '<CHANNEL_ID>' // optional
  },
};

const Globals = {
  playerScript: null,
  s73Script: null,
  s73Wrapper: null,
  player: null,
};

const onLoadS73 = (event, props) => {
  const playerConfig = {
    playlist: props.custom_3_playerConfiguration.playlist,
    ...props.custom_3_playerConfiguration.customProps,
    key: ExternalConfiguration.Credentials.Custom_3_playerLicenseKey,
  };

  Globals.s73Wrapper = window.S73JwplayerWrapper( Constants.S73SdkConfig);
  Globals.s73Wrapper.wrapPlayerConfig( playerConfig);
  Globals.player = window.jwplayer( Constants.PlayerId);
  Globals.s73Wrapper.wrapPlayer( Globals.player);
  Globals.player.setup( playerConfig);
};

const onLoadPlayer = (event, props) => {
  Globals.s73Script = document.createElement( 'script');
  Globals.s73Script.src = Constants.S73ScriptSrc;
  Globals.s73Script.async = true;
  Globals.s73Script.onload = event => onLoadS73( event, props);
  document.head.append( Globals.s73Script );
};

export default function Wrapper_custom_3_s73_player( props) {
  const { width, height } = props.custom_3_playerConfiguration?.customProps ?? {};
  const { PlayerId, PlayerScritpSrc } = Constants;
  const { player } = Globals;

  if( player && (player.getWidth() !== width || player.getHeight() !== height)) player.resize( width, height);

  useEffect( () => {
    Globals.playerScript = document.createElement( 'script');
    Globals.playerScript.src = PlayerScritpSrc;
    Globals.playerScript.async = true;
    Globals.playerScript.onload = event => onLoadPlayer( event, props);
    document.head.append( Globals.playerScript );
  }, []);

  return (
    <div className='wrapper-custom-3-s73-player-container' style={{ width: window.innerWidth, height: window.innerHeight }}>
      <div id={PlayerId} style={{ width: '100%', height: '100% '}}/>
    </div>
  );
}
